import { OWL, EASYBIB, CITATION_MACHINE, CHEGG, BIBME, CHEGG_SIHP, CITE_THIS_FOR_ME } from '../types';
import { colors } from '@chegg-ui/theme';
export var OWL_UTM_PARAMS = {
  utm_source: 'owl',
  utm_medium: 'ulw',
  utm_campaign: 'version2'
};
export var CHEGG_SIHP_UTM_PARAMS = {
  utm_source: 'sihp',
  utm_medium: 'ulw',
  utm_campaign: 'version2'
};
export var selectSite = function selectSite(state) {
  return state.site;
};
export var selectCollapsed = function selectCollapsed(state) {
  return state.site === OWL ? true : false;
};
export var selectDisplayLegal = function selectDisplayLegal(state) {
  return state.site === OWL || state.site === CHEGG_SIHP ? false : true;
};
export var selectUtmQueryParams = function selectUtmQueryParams(state) {
  switch (state.site) {
    case OWL:
      return OWL_UTM_PARAMS;
    case CHEGG_SIHP:
      return CHEGG_SIHP_UTM_PARAMS;
    default:
      return null;
  }
};
export var selectTermsAndConditionsUrl = function selectTermsAndConditionsUrl(state) {
  switch (state.site) {
    case EASYBIB:
      return "https://writing.easybib.com/free-trial-terms-and-conditions";
    case CITATION_MACHINE:
      return "https://writing.citationmachine.net/free-trial-terms-and-conditions";
    case CHEGG:
      return "https://writing.chegg.com/free-trial-terms-and-conditions";
    case BIBME:
      return "https://writing.bibme.org/free-trial-terms-and-conditions";
    default:
      return "https://writing.chegg.com/free-trial-terms-and-conditions";
  }
};
export var selectLoadingIconAttributes = function selectLoadingIconAttributes(state) {
  switch (state.site) {
    case OWL:
      {
        return {
          iconColor: '#D78540'
        };
      }
    case BIBME:
      {
        return {
          iconColor: '#228EB5'
        };
      }
    case CITATION_MACHINE:
      {
        return {
          iconColor: '#D78541'
        };
      }
    case CITE_THIS_FOR_ME:
      {
        return {
          iconColor: '#2E5898'
        };
      }
    case CHEGG_SIHP:
    case EASYBIB:
    default:
      return {
        iconColor: colors.cheggOrange
      };
  }
};
export var selectButtonAttributes = function selectButtonAttributes(state) {
  switch (state.site) {
    case OWL:
      {
        return {
          buttonColor: '#D78540',
          buttonHoverColor: '#D46E00',
          buttonTextColor: colors.white,
          buttonDisabledColor: '#D78540',
          buttonDisabledTextColor: colors.white,
          disabledOpacity: '50%',
          borderRadius: '8px'
        };
      }
    case BIBME:
      {
        return {
          buttonColor: '#228EB5',
          buttonHoverColor: '#196E89',
          buttonTextColor: colors.white
        };
      }
    case CITATION_MACHINE:
      {
        return {
          buttonColor: '#D78541',
          buttonHoverColor: '#AC6A34',
          buttonTextColor: colors.white
        };
      }
    case CITE_THIS_FOR_ME:
      {
        return {
          buttonColor: '#2E5898',
          buttonHoverColor: '#103368',
          buttonTextColor: colors.white
        };
      }
    case CHEGG_SIHP:
      {
        return {
          buttonColor: '#21a29d',
          buttonHoverColor: '#188e87',
          buttonTextColor: colors.white,
          borderRadius: '8px',
          fontSize: '20px'
        };
      }
    case EASYBIB:
    default:
      return {
        buttonColor: colors.cheggOrange,
        buttonHoverColor: colors.orangeDark,
        buttonTextColor: colors.white,
        buttonDisabledColor: colors.greyLight,
        buttonDisabledTextColor: colors.greyMedium
      };
  }
};